import { canauxChoisis } from '../canaux'
import { libelleUnite } from './wizardConstants'

/**
 * Etape 5 (parcours A) : « Stock & recap » — prototype v7.4, WizardOffre/stock.
 *
 * Un champ pour la quantite disponible (le stock est PARTAGE entre les canaux :
 * ce qui part d'un cote baisse de l'autre — c'est la promesse « un seul stock »
 * de Mes offres), puis un recapitulatif en carte de verre : produit, canaux,
 * type. Le bouton final est ORANGE, seul de tout le wizard — c'est l'acte.
 *
 * Le stock est persiste a la creation (`CreateProducerOfferDto.stock`, ajoute
 * en S68 : le modele et le service le portaient deja, seul le DTO le bloquait).
 */
function StepStockRecap({ product, catalogue, canaux, exclusif, customName, stock, onStockChange, unite }) {
  const uniteEff = libelleUnite(unite || product?.unit || 'kg')
  const canauxActifs = canauxChoisis(catalogue, canaux).map((c) => c.l)
  return (
    <div>
      <p className="text-[13px] text-ink/65 mb-2">Quantité disponible (stock partagé entre vos canaux)</p>
      <div className="flex items-center gap-2 mb-4">
        <input
          value={stock}
          inputMode="numeric"
          onChange={(e) => onStockChange(e.target.value.replace(/\D/g, ''))}
          placeholder="0"
          className="flex-1 min-w-0 rounded-[14px] px-3.5 py-3 text-base font-serif text-ink outline-none"
          style={{ background: 'rgba(255,255,255,0.6)', border: '1px solid rgba(7,62,61,0.12)' }}
        />
        <span className="text-[13px] text-ink/60 flex-shrink-0">{uniteEff}</span>
      </div>

      <div className="panneau-verre rounded-[18px] px-[15px] py-[13px]">
        <p className="text-[10.5px] font-bold uppercase mb-2" style={{ letterSpacing: 1.5, color: 'rgb(var(--c-teal))' }}>
          Récapitulatif
        </p>
        <p className="text-[13.5px] text-ink leading-[1.7]">
          {product?.emoji || product?.category?.emoji || '📦'} <strong>{customName || product?.nom}</strong>
          {product?.category?.nom ? ` · ${product.category.nom}` : ''}<br />
          Canaux : {canauxActifs.join(', ') || 'aucun'}<br />
          {exclusif ? '🔒 Ma marque' : '🌍 Générique'}
          {/* Prototype : une proposition rejoint le wizard, sa reference part en validation */}
          {product?.proposition ? <><br />🕓 Référence en validation Manrina</> : null}
        </p>
      </div>
    </div>
  )
}

export default StepStockRecap
